import { useContext } from "react";
import loader from "../../assets/images/svgicons/loader.svg";
import { AppContext } from "../../context/AppProvider";

type LoaderProps = {
  loading?: boolean;
};

const FullLoader: React.FC<LoaderProps> = () => {
  const { state } = useContext(AppContext);
  return (
    <>
      {(state.contentLoading || state.loading) && (
        <div
          className="fixed top-0 left-0 w-screen h-screen z-50"
          style={{ background: "rgba(0, 0, 0, 0.7)" }}
        >
          <div className="fixed top-2/4 left-2/4 ">
            <img src={loader} alt={" "} className="top-2/4 left-2/4  w-[80px] h-[80px]" />
          </div>
        </div>
      )}
    </>
  );
};
export default FullLoader;
